import { Pipe, PipeTransform } from '@angular/core';
import { NormalizeStringPipe } from '../normalizeString/normalizeString.pipe';
import * as EE_counties from '../../../assets/geojson/EE.geo.json';
import * as EE_cities from '../../../assets/geojson/EE.geo.cities.json';
import * as LV_counties from '../../../assets/geojson/LV.geo.json';
import * as LV_cities from '../../../assets/geojson/LV.geo.cities.json';
import * as LT_counties from '../../../assets/geojson/LT.geo.json';
import * as LT_cities from '../../../assets/geojson/LT.geo.cities.json';
import * as BY_counties from '../../../assets/geojson/BY.geo.json';
import * as BY_cities from '../../../assets/geojson/BY.geo.cities.json';

@Pipe({
  name: 'mapStringToLocation'
})
export class MapStringToLocationPipe implements PipeTransform {
  resolved: any = {};

  constructor(private normalizeStringPipe: NormalizeStringPipe) {
    [EE_counties, LV_counties, LT_counties, BY_counties].forEach(country => {
      country?.features.forEach(item => {
        if (item?.properties) {
          this.resolved[normalizeStringPipe.transform(item.properties.VARNAME_1)] = item.properties.VARNAME_1;
          this.resolved[normalizeStringPipe.transform(item.properties.VARNAME_1).split(' ')[0]] = item.properties.VARNAME_1;
          if (item.properties.ALIAS_1?.length) {
            this.resolved[normalizeStringPipe.transform(item.properties.ALIAS_1)] = item.properties.VARNAME_1;
          }
        }
      });
    });
    [EE_cities, LV_cities, LT_cities, BY_cities].forEach(country => {
      country?.items.forEach(item => {
        this.resolved[normalizeStringPipe.transform(item.city)] = item.city;
      });
    });
  }

  transform(input: string, canBeEmpty?: boolean): string {
    const normalize = this.normalizeStringPipe.transform(input);
    if (input) {
      const match = this.resolved[normalize] || this.resolved[normalize.split(' ')[0]];
      if (match) {
        return match;
      }
    }
    if (!canBeEmpty) {
      return input;
    }
  }
}
